<template>
<!-- (팝업) 210121 일괄 배송지 변경 -->
  <div class="layer_section-container">
    <div class="layer-header">
      <h1 class="header-title pad">
        주문하신 마이팩의 배송지를 일괄 변경하시겠습니까?
      </h1>
    </div>
    <div class="layer-content">
      <div class="pop-orderCancel-area">
        <ul class="number-list">
          <li v-for="(pack,index) in groupList" :key="index">
            <div class="str_cut">{{ pack.mypack_name }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="align-box size-auto">
      <button type="button" class="btn-modal_confirm" @click="onDispose">취소</button>
      <button type="button" class="btn-modal_close v2" @click="onOk">확인</button>
    </div>
  </div>
<!-- //(팝업) 210121 일괄 배송지 변경  -->
</template>
<script>
export default {
    name: 'PopupChangeGroupDelivery',
    props: {
      groupList: {
        type: Array,
        default: null
      }
    },
    methods: {
      onDispose() {
        this.$emit('dispose', 'get out!');
      },
      onOk() {
        this.$emit('dispose', 'get out!');
        this.$emit('ok');
      }
    }
}
</script>